export default {
      id: "ic-misc-phone-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ic-misc-phone-usage",
      toString: function () {
        return this.url;
      }
    }